'use strict';
import moment from 'moment-timezone';
angular.module('docketbook').
  controller('jobMobileDetailController', function(jobService, userService, orderService, $rootScope, $scope, $state, $window, $stateParams, $mdpDatePicker, $mdpTimePicker, $mdToast, $mdBottomSheet, splitListInterface, $http, Restangular, accessControl, uuid, $timeout, scroll, geolocation) {
    mixpanel.track("Opened JobsDetail Mobile");

    /***************************/
    /***** Setup Variables *****/
    /***************************/

    $scope.moment = moment;
    $scope.listItems = [];
    $scope.itemEdit = null;
    $scope.viewState = 'docket';
    $scope.jobLoadingError = null;
    $scope.cleanAssignees = [];

    // Data
    $scope.currentUser = accessControl.currentUser();
    $scope.currentOrgGroup = accessControl.currentOrgGroup();
    $scope.currentOrg = accessControl.currentOrg();

    // Include responsive utilities and UI functionality helpers
    $scope.splitListFunc = new splitListInterface($scope, $stateParams);

    /**********************/
    /**** Permissions *****/
    /**********************/

    $scope.userHasPermission = function(permissionName) {
      return accessControl.userHasPermission(permissionName);
    }

    $scope.userCanDoAction = userService.userCanDoAction;

    /************************************/
    /***** Job Detail View Controls *****/
    /************************************/

    $scope.openJobMobile = function(job, tabToOpen) {
      $scope.jobLoadingError = null;
      $scope.viewState = 'job';
      var openTab = tabToOpen;
      if ( $stateParams.openTab != null ) {
        openTab = $stateParams.openTab;
      }
      $scope.prepareForJobFromParent(openTab, null, job);
      jobService.getJob(job, function(jobFull) {
        // setup quantities on lines
        for ( var i = 0; i < jobFull.lineItems.length; i++ ) {
          if ( jobFull.lineItems[i].resource.uom.isTime ) {
            var quantity = jobFull.lineItems[i].quantity;
            var hours = Math.floor(quantity/60);
            var minutes = quantity % 60;
            jobFull.lineItems[i].quantityHoursEdit = hours;
            jobFull.lineItems[i].quantityMinutesEdit = minutes;
          } else {
            jobFull.lineItems[i].quantityEdit = jobFull.lineItems[i].quantity;
          }
        }

        if ( accessControl.userHasPermission('io.docketbook.ojdapi.getOrder') && jobFull.orderRef != null ) {
          orderService.getOrder(jobFull.orderRef, function(orderFull) {
            jobFull.orderRef = orderFull;
            $scope.lastCleanJob = angular.copy(jobFull);
            $scope.loadJobFromParent(jobFull);
            return;
          }, function(err) {
            if ( jobFull.order != null ) {
              var newOrderRef = {};
              newOrderRef.id = jobFull.order.orderId;
              newOrderRef.orderNumber = jobFull.order.orderNumber;
              jobFull.orderRef = newOrderRef;
            }
            $scope.lastCleanJob = angular.copy(jobFull);
            $scope.loadJobFromParent(jobFull);
            return;
          });
        } else {
          if ( jobFull.order != null ) {
            var newOrderRef = {};
            newOrderRef.id = jobFull.order.orderId;
            newOrderRef.orderNumber = jobFull.order.orderNumber;
            jobFull.orderRef = newOrderRef;
          }
        }

        $scope.lastCleanJob = angular.copy(jobFull);
        $scope.loadJobFromParent(jobFull);
      }, function(err) {
        $scope.jobLoadingErrorFull = err;
        if ( err.status == 403 ) {
          $scope.jobLoadingError = "You do not have permission to access this job";
        } else {
          $scope.jobLoadingError = "Error Getting Job";
        }
      });
    }

    $scope.newJob = function(fromId) {
      $scope.viewState = 'job';
      $scope.newJobFromParent(fromId);
    }

    $scope.closeWithoutSave = function(job) {
      var currentJob = $scope.getJobFromParent();
      jobService.getJobDiff($scope.lastCleanJob, currentJob, function(diff, diffCount) {
        if ( diffCount > 0 ) {
          var buttonActions = [{title:'Save',action:'save',colour:'green'}, {title:"Don't Save",action:'dontSave',colour:'red'}, {title:"Cancel",action:'cancel',colour:'grey'}];
          $scope.alertService.presentConfirmAlert('Unsaved Changes', 'Would you like to save changes before exiting?', buttonActions, function(actionSelected) {
            if ( actionSelected == 'save' ) {
              jobService.saveJob(diff, function(jobUpdated) {
                $scope.closeJob();
              }, function(err) {
                $scope.alertService.presentAutoAlert('saveJob', err);
              });
            } else if ( actionSelected == 'dontSave' ) {
              $scope.closeJob();
            } else {
              // do nothing - stay where we are
            }
          });
          return;
        } else {
          $scope.closeJob();
        }
      });
    }

    $scope.closeJob = function() {
      var stateBack = {};
      if ( $stateParams.stateTrail && $stateParams.stateTrail.length > 0 ) {
        stateBack = $stateParams.stateTrail[$stateParams.stateTrail.length - 1];
      }
      var stateOptions = {};
      if ( stateBack.orderId ) {
        stateOptions.orderId = stateBack.orderId;
      }
      if ( stateBack.jobId ) {
        stateOptions.jobId = stateBack.jobId;
      }
      if ( stateBack.docketId ) {
        stateOptions.docketId = stateBack.docketId;
      }
      if ( stateBack.fromTab ) {
        stateOptions.openTab = stateBack.fromTab;
      }
      if ( stateBack.orgId ) {
        stateOptions.orgId = stateBack.orgId;
      }
      if ( stateBack.groupId ) {
        stateOptions.groupId = stateBack.groupId;
      }
      if ( stateBack.name ) {
        if ( stateBack.name == 'main.groupJobDetail' && stateOptions.jobId == 'new' ) {
          $state.go('main.groupJobs', stateOptions);
        } else {
          $state.go(stateBack.name, stateOptions);
        }
      } else {
        if ( $scope.currentOrg != null ) {
          $state.go('main.groupJobs', {orgId:$scope.currentOrg.id, groupId:$scope.currentOrgGroup.id});
        } else {
          $state.go('main.jobs');
        }
      }
    }

    $scope.deleteJob = function(job) {
      jobService.deleteJob(job.id, function() {
        $scope.closeJob();
      }, function(err) {
        $scope.alertService.presentAutoAlert('deleteJob', err);
      });
    }

    $scope.saveAndStay = function(job) {
      var newJob = false;
      if ( job.id == null ) {
        newJob = true;
      }
      job.loading = true;
      job.loadingType = 'saving';
      jobService.getJobDiff($scope.lastCleanJob, job, function(diff, diffCount) {
        if ( diffCount > 0 ) {
          jobService.saveJob(diff, function(jobUpdated) {
            job.loading = false;
            if ( newJob ) {
              $scope.showToast('New Job Saved');
              $state.go('main.groupJobDetail', {orgId:$scope.currentOrg.id, groupId:$scope.currentOrgGroup.id, jobId:jobUpdated.id});
              //$scope.openJobMobile(jobUpdated);
            } else {
              $scope.showToast('Job Changes Saved');
              $scope.openJobMobile(jobUpdated.id, $scope.currentActiveTab());
            }
          }, function(err) {
            job.loading = false;
            $scope.alertService.presentAutoAlert('saveJob', err);
          });
        } else {
          job.loading = false;
        }
      });
    }

    /********************************/
    /***** MAIN OPENING CONTROLS ****/
    /********************************/

    // Parameter controls
    $scope.detailControllerReady = function() {
      if ( $stateParams.jobId != null ) {
        if ( $stateParams.jobId == 'new' ) {
          if ( $stateParams.fromOrder != null ) {
            $scope.newJob($stateParams.fromOrder);
          } else {
            $scope.newJob();
          }
        } else {
          $scope.openJobMobile($stateParams.jobId);
        }
      }
    }

    /*****************************/
    /***** Job State Actions *****/
    /*****************************/

    $scope.sendJob = function(job) {
      $mdBottomSheet.hide();
      job.loading = true;
      jobService.validateSendJob(job, function() {
        jobService.getJobDiff($scope.lastCleanJob, job, function(diff, diffCount) {
          if ( diffCount > 0 ) {
            diff.status = 'sent';
            jobService.saveJob(diff, function(jobUpdated) {
              $scope.showToast('Job Sent');
              $scope.openJobMobile(jobUpdated.id);
            }, function(err) {
              job.loading = false;
              $scope.alertService.presentAutoAlert('sendJob', err);
            });
          } else {
            jobService.sendJob(job, function() {
              $scope.showToast('Job Sent');
              $scope.openJobMobile(job.id);
            }, function(err) {
              job.loading = false;
              $scope.alertService.presentAutoAlert('sendJob', err);
            });
          }
        });
      }, function(exceptions) {
        job.loading = false;
        $scope.alertService.presentAutoValidationAlert('sendJob', exceptions);
      });
    }

    $scope.closeJobStatus = function(job) {
      $mdBottomSheet.hide();
      job.loading = true;
      jobService.closeJob(job, function() {
        $scope.showToast('Job Closed');
        $scope.openJobMobile(job.id);
      }, function(err) {
        job.loading = false;
        $scope.alertService.presentAutoAlert('closeJob', err);
      });
    }

    $scope.assigneeChangeStatus = function(job, statusTo, method) {
      $mdBottomSheet.hide();
      if ( statusTo.toLowerCase() == 'rejected' ) {
        // check if assignee has any dockets created for this job
        var authoredDocketsCount = 0;
        for ( var i = 0; i < job.dockets.length; i++ ) {
          if ( job.dockets[i].author == $scope.currentUser.id ) {
            authoredDocketsCount += 1;
          }
        }
        if ( authoredDocketsCount > 0 ) {
          $scope.alertService.presentAutoAlert('rejectJobWithDockets', {status:400});
          return;
        }
        swal({
          title: "Reject Job " + job.jobNumber,
          text: "Please provide a reason for rejecting this job.",
          type: "input",
          showCancelButton: true,
          closeOnConfirm: true,
          inputPlaceholder: "Reason"
        }, function(inputValue){
          if ( inputValue === false ) {
            return;
          }
          jobService.assigneeStatusChange(job, job.userAssigneeData.assignee, statusTo, inputValue, function(success) {
            $scope.showToast('Job Status Updated');
            $scope.openJobMobile(job.id);
          }, function(err) {
            $scope.alertService.presentAutoAlert('jobStatusChange', err);
          });
        });
      } else {
        jobService.assigneeStatusChange(job, job.userAssigneeData.assignee, statusTo, null, function(success) {
          $scope.showToast("Job Status Updated");
          $scope.openJobMobile(job.id);
        }, function(err) {
          $scope.alertService.presentAutoAlert('jobStatusChange', err);
        });
      }
    }

    /******************************/
    /***** List View Controls *****/
    /******************************/

    $scope.showJobDetail = function() {
      $scope.viewState = 'job';
      if ($scope.itemEdit.organisation === $scope.currentOrg.id) {
        $scope.cleanAssignees = $scope.itemEdit.assignees
      } else {
        $scope.cleanAssignees = $scope.itemEdit.assignees.filter((assignee) => {
          if (('organisation' in assignee) && ('organisationGroup' in assignee)) {
            return assignee.organisation === $scope.currentOrg.id && assignee.organisationGroup === $scope.currentOrgGroup.id;
          }
          return true;
        })
      }
    }

    $scope.selectOrderForJob = function(options, cb) {
      $scope.viewState = 'order';
      $scope.selectOrderCallback = cb;
      $scope.orderSelectFromParent(options, function(orderSelected) {
        $scope.selectOrderCallback(orderSelected);
        $scope.showJobDetail();
      });
    }

    $scope.selectPersonForJob = function(assignedUsers, cb) {
      $scope.viewState = 'assignee';
      $scope.selectPersonCallback = cb;
      $scope.personSelectFromParent(assignedUsers, function(personSelected) {
        $scope.selectPersonCallback(personSelected);
        $scope.showJobDetail();
      });
    }

    $scope.selectLineFromOrder = function(sourceList, cb) {
      $scope.viewState = 'lines';
      $scope.selectLineCallback = cb;
      $scope.lineSelectFromParent(sourceList, function(lineSelected) {
        $scope.selectLineCallback(lineSelected);
        $scope.showJobDetail();
      });
    }

    $scope.selectContactForJob = function(cb) {
      $scope.viewState = 'company';
      $scope.selectContactCallback = cb;
      $scope.contactSelectFromParent(null,null,function(companySelected) {
        $scope.selectContactCallback(companySelected);
        $scope.showJobDetail();
      });
    }

    /**************************/
    /***** Modal Controls *****/
    /**************************/

    $scope.editLineItemForJob = function(job, item, cb) {
      $scope.editLineItemCallback = cb;
      $scope.editLineItemFromParent(job, item, function(lineItem) {
        $scope.editLineItemCallback(lineItem);
      });
    }

    /**********************************/
    /***** Comments Functionality *****/
    /**********************************/

    $scope.addCommentToJob = function(job, commentText) {
      var comment = {};
      comment.comment = commentText;
      comment.author = $scope.currentUser.id;
      comment.authorName = $scope.currentUser.name.full;
      comment.date = moment().toISOString();

      jobService.addComment(job, comment, function(jobUpdated) {
        job.comments = jobUpdated.comments;
      }, function(err) {
        $scope.alertService.presentAutoAlert('addJobComment',err);
      });
    }

    $scope.removeCommentFromJob = function(job, comment) {
      jobService.deleteComment(job, comment, function(jobUpdated) {
        job.comments = jobUpdated.comments;
      }, function(err) {
        $scope.alertService.presentAutoAlert('removeJobComment',err);
      });
    }

    $scope.addAssigneeComment = function(job, commentText) {
      jobService.addAssigneeComment(job, commentText, function(jobUpdated) {
        $scope.newComment = {'commentText':''};
        job.comments = jobUpdated.comments;
      }, function(error) {
        $scope.alertService.presentAutoAlert('addJobComment',error);
      });
    }

    $scope.deleteAssigneeComment = function(job, comment) {
      if ( $scope.currentUser.id == comment.author ) {
        jobService.deleteAssigneeComment(job, comment, function(jobUpdated) {
          job.comments = jobUpdated.comments;
        }, function(error) {
          $scope.alertService.presentAutoAlert('removeJobComment',error);
        });
      }
    }

    $scope.clearComment = function(comment) {
      $scope.resetNewComment();
    }

    $scope.toggleCommentControls = function(comment) {
      if ( $scope.userHasPermission('io.docketbook.ojdapi.updateJob') || comment.author == $scope.currentUser.id ) {
        comment.showControls = !comment.showControls;
      }
    }

    /**************************************/
    /***** Infinite scrolling methods *****/
    /**************************************/

    $scope.loadingMoreItems = false;
    $scope.docketsListLoadingCount = 0;
    angular.element($window).bind('scroll', function() {
      if ( $(window).scrollTop() + $(window).height() > $(document).height() - 20 ) {
        if ( $scope.currentActiveTab() == 'Dockets' && !$scope.loadingMoreItems ) {
          // load next page of dockets
          $scope.loadingMoreItems = true;
          $("#docketsLoadingMore").removeClass("hidden");
          $scope.loadJobDocketsNextPage(function() {
            $scope.loadingMoreItems = false;
            $("#docketsLoadingMore").addClass('hidden');
          });
        }
      }
    });

    /*****************************/
    /**** New Docket For Job *****/
    /*****************************/

    $scope.newDocketForJob = function() {
      var currentJob = $scope.getJobFromParent();
      jobService.validateCreateDocket(currentJob, function() {
        if ( currentJob != null && currentJob.editing ) {
          jobService.getJobDiff($scope.lastCleanJob, currentJob, function(diff, diffCount) {
            if ( diffCount > 0 ) {
              swal({
                title: "Unsaved Changes",
                text: "You have some unsaved changes on this job, are you sure you want to close without saving?",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Yes, close job.",
                cancelButtonText: "No, dont close job.",
                closeOnConfirm: true ,
                closeOnCancel: true
              }, function(isConfirm){
                if (isConfirm) {
                  goToNewDocket(currentJob);
                }
              });
            } else {
              goToNewDocket(currentJob);
            }
          });
        } else {
          goToNewDocket(currentJob);
        }
      }, function(exceptions) {
        currentJob.loading = false;
        $scope.alertService.presentAutoValidationAlert('jobCreateDocket', exceptions);
      });
    }

    var goToNewDocket = function(currentJob) {
      var currentTab = $scope.currentActiveTab();
      if ( $scope.currentOrg && $scope.currentOrgGroup ) {
        $state.go('main.groupDocketDetail', {docketId:'new', fromJob: currentJob.id, fromTab:currentTab, orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id});
      } else if ( currentJob.userAssigneeData ) {
        $state.go('main.groupDocketDetail', {docketId:'new', fromJob: currentJob.id, fromTab:currentTab, orgId: currentJob.userAssigneeData.organisation, groupId: currentJob.userAssigneeData.organisationGroup});
      }
    }

    $scope.openDocket = function(docket) {
      var currentJob = $scope.getJobFromParent();
      if ( currentJob != null && currentJob.editing ) {
        jobService.getJobDiff($scope.lastCleanJob, currentJob, function(diff, diffCount) {
          if ( diffCount > 0 ) {
            swal({
              title: "Unsaved Changes",
              text: "You have some unsaved changes on this job, are you sure you want to close without saving?",
              type: "warning",
              showCancelButton: true,
              confirmButtonColor: "#DD6B55",
              confirmButtonText: "Yes, close job.",
              cancelButtonText: "No, dont close job.",
              closeOnConfirm: true ,
              closeOnCancel: true
            }, function(isConfirm){
              if (isConfirm) {
                goToDocket(docket, currentJob);
              }
            });
          } else {
            goToDocket(docket, currentJob);
          }
        });
      } else {
        goToDocket(docket, currentJob);
      }
    }

    var goToDocket = function(docket, currentJob) {
      if ( $scope.currentOrg && $scope.currentOrgGroup ) {
        $state.go('main.groupDocketDetail', { docketId: docket.id, fromTab: 'Dockets', orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
      } else if ( currentJob.userAssigneeData && currentJob.userAssigneeData.organisation && currentJob.userAssigneeData.organisationGroup ) {
        $state.go('main.groupDocketDetail', { docketId: docket.id, fromTab: 'Dockets', orgId: currentJob.userAssigneeData.organisation, groupId: currentJob.userAssigneeData.organisationGroup });
      } else {
        $state.go('main.docketDetail', { docketId: docket.id, fromTab: "Dockets"});
      }
    }

    /******************/
    /***** Toasts *****/
    /******************/

    $scope.showToast = function(message) {
      var toast = {};
      if ( $stateParams.device == 'desktop' ) {
        toast = $mdToast.simple()
          .textContent(message)
          .position('top right')
          .hideDelay(3000);
      } else {
        toast = $mdToast.simple()
          .textContent(message)
          .position('top right')
          .hideDelay(3000)
          .capsule(false)
          .parent(document.querySelectorAll('#toasterInner'));
      }
      $mdToast.show(toast).then();
    }

    /*****************************/
    /***** Date/Time Pickers *****/
    /*****************************/

    $scope.showDatePicker = function(field, ev) {
      $mdpDatePicker($scope.itemEdit[field], {
        targetEvent: ev
      }).then(function(selectedDate) {
        $scope.itemEdit[field] = selectedDate;
      });
    }

    $scope.showTimePicker = function(field, ev) {
      $mdpTimePicker($scope.itemEdit[field], {
        targetEvent: ev,
        autoSwitch: true
      }).then(function(selectedTime) {
        $scope.itemEdit[field] = selectedTime;
      });
    }

});



// WEBPACK FOOTER //
// ./src/controllers/jobs/mobileDetailController.js